// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import React from 'react';

import { LoadableLazy, LoadablePaint } from '@confluence/loadable';

import { PresentationModePlaceholder } from './PresentationModePlaceholder.tsx';

export const PresenterModeContextProvider = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PresenterModeContext" */ './PresenterModeContext.tsx'))
			.PresenterModeContextProvider,
});

export const LazyPresenterModeContextConsumer = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PresenterModeContext" */ './PresenterModeContext.tsx'))
			.PresenterModeContextConsumer,
	loading: () => <PresentationModePlaceholder />,
});

export { usePresenterModeContext } from './PresenterModeContext.tsx';
